import React from "react";

const NXTablerLink = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13.9999C10.3259 14.3325 10.7148 14.5967 11.1441 14.7771C11.5734 14.9575 12.0344 15.0504 12.5 15.0504C12.9656 15.0504 13.4266 14.9575 13.8559 14.7771C14.2852 14.5967 14.6741 14.3325 15 13.9999L19 9.99989C19.663 9.33685 20.0355 8.43757 20.0355 7.49989C20.0355 6.56221 19.663 5.66293 19 4.99989C18.337 4.33685 17.4377 3.96436 16.5 3.96436C15.5623 3.96436 14.663 4.33685 14 4.99989L13.5 5.49989"
        stroke="#111827"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 9.99973C13.6741 9.66713 13.2852 9.4029 12.8559 9.22252C12.4266 9.04213 11.9656 8.94922 11.5 8.94922C11.0344 8.94922 10.5734 9.04213 10.1441 9.22252C9.71486 9.4029 9.32589 9.66713 9.00001 9.99973L5.00001 13.9997C4.33697 14.6628 3.96448 15.562 3.96448 16.4997C3.96448 17.4374 4.33697 18.3367 5.00001 18.9997C5.66305 19.6628 6.56233 20.0353 7.50001 20.0353C8.43769 20.0353 9.33697 19.6628 10 18.9997L10.5 18.4997"
        stroke="#111827"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NXTablerLink;
